import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
const DEFAULT_CLASSES = {
  container:
    "flex ph2 ba br2 items-center h2 hairline-1 mv2 mv0-ns black-80 bg-white",
  copy: "f6 lh-copy"
};

const Callout = ({ copy, customStyles, customClasses, children }) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };

  return (
    <div className={classes.container}>
      <div
        className={classnames(classes.copy, {
          pr2: Boolean(children)
        })}
      >
        {copy}
      </div>
      {children}
    </div>
  );
};

Callout.propTypes = {
  copy: PropTypes.string,
  customClasses: PropTypes.object,
  customStyles: PropTypes.object
};
export default Callout;
